/**
 * O enum que representa os tipos de erro que podem ser emitidos durante a verificação de requisitos para emitir um certificado
 */
export enum UserCertificateErrorsEnum {
  /**
   * Indica que o usuário não tem o número de presença mínima no tipo de chamada {TEAM_PRESENCES}
   */
  PRESENCE_TEAM_REQUIRED = 'presence_team_required',

  /**
   * Indica que o usuário não tem o número de presença mínima no tipo de chamada {WATCHING_LESSONS}
   */
  PRESENCE_WATCH_REQUIRED = 'presence_watch_required',

  /**
   * Indica que o usuário não tem a porcentagem de acerto mínimo dos quizes
   */
  QUIZ_REQUIRED = 'quiz_required',

  /**
   * É usado para saber se ocorreu algum erro fora do previsto (ex: erro interno na API)
   *
   * @note Só é usado dentro do FRONT
   */
  UNKNOWN = 'unknown',

}
